import Cookies from 'js-cookie';

const globalParams: Record<string, unknown> = {};

export const setGlobalAnalyticsParam = (key: string, value: string) => {
  globalParams[key] = value;
};

export const deleteGlobalAnalyticsParam = (key: string) => {
  delete globalParams[key];
};

export const getGlobalAnalyticsParams = (): Record<string, unknown> => {
  return {
    ...globalParams,
    pseudo_user_id:
      Cookies.get('_ga')?.replace('GA1.1.', '') || globalParams.pseudo_user_id,
  };
};
